module.exports = __webpack_public_path__ + "assets/img/NVIDIA-f9e35da1.png";